import { Navigate, useLocation } from 'react-router-dom';
import type { ReactNode } from 'react';

import { RouteNames } from '@/shared/config/routes';
import { useAppSelector } from '@/shared/lib';

interface AuthGuardProps {
  children: ReactNode;
  requireAuth?: boolean;
}

export const AuthGuard = ({ children, requireAuth = true }: AuthGuardProps) => {
  const isAuthenticated = useAppSelector((state) => state.auth.isAuthenticated);
  const location = useLocation();

  if (requireAuth && !isAuthenticated) {
    return <Navigate to={RouteNames.LOGIN} state={{ from: location }} replace />;
  }

  if (!requireAuth && isAuthenticated) {
    const from = location.state?.redirect || RouteNames.HOME;
    return <Navigate to={from} replace />;
  }

  return <>{children}</>;
};
